const Env = {
	PROD: "PROD",
	PREPROD: "PREPROD",
	DEV: "DEV",
} as const;

type Env = (typeof Env)[keyof typeof Env];

type EnvVariable = {
	GOOGLE_TAG_MANAGER_TAG_ID: string;
	TRACKING_PAGE_URL: string;
};

export const getEnv = (): Env => {
	const prodRegExp = /^station-display.bus.blablacar.com/i;
	if (prodRegExp.test(window.location.host)) return Env.PROD;

	const preProdRegExp = /^station-display.preprod-1.blbl.cr/i;
	if (preProdRegExp.test(window.location.host)) return Env.PREPROD;

	return Env.DEV;
};

export const getEnvVariables = (): EnvVariable => {
	if (getEnv() === Env.PROD) {
		return {
			GOOGLE_TAG_MANAGER_TAG_ID: "G-63BJLRP7J1",
			TRACKING_PAGE_URL: "https://tracking.bus.blablacar.com/",
		};
	}

	if (getEnv() === Env.PREPROD) {
		return {
			GOOGLE_TAG_MANAGER_TAG_ID: "",
			TRACKING_PAGE_URL: "https://tracking-bus.preprod-1.blbl.cr/",
		};
	}

	return {
		GOOGLE_TAG_MANAGER_TAG_ID: "",
		TRACKING_PAGE_URL: "https://tracking-bus.preprod-1.blbl.cr/",
	};
};
